import { render, staticRenderFns } from "./TracingRoutesTable.vue?vue&type=template&id=89bc9834&scoped=true"
import script from "./TracingRoutesTable.vue?vue&type=script&lang=js"
export * from "./TracingRoutesTable.vue?vue&type=script&lang=js"
import style0 from "./TracingRoutesTable.vue?vue&type=style&index=0&id=89bc9834&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89bc9834",
  null
  
)

export default component.exports